
export default {
    layout: {
        single_page: function(current_data){
            var column_data = adapt.ui.layout.helper_functions.unwrap_columns(current_data);
            var html = "";
            for (var i = 0; i < column_data.length; i++){
                if (i > 0){
                    html = html + "<hr>";
                }
                
                html = html + column_data[i];
            }
            
            return html;
        },
        
        two_equal_columns: function(current_data){
            var column_data = adapt.ui.layout.helper_functions.unwrap_columns(current_data);
            var $layout = $('<div class="layout not-editable"><div class="columns not-editable"><div class="column editable"><p><br></p></div><div class="column editable"><p><br></p></div></div></div>');
            
            if (column_data.length >= 1){  
                var $column = $($layout.find('.column').get(0));
                $column.empty();
                $column.append(column_data[0]);
            }
            
            if (column_data.length >= 2){
                var $column = $($layout.find('.column').get(1));
                $column.empty();
                $column.append(column_data[1]);
            }
            
            if (column_data.length >= 3){
                for(var i = 2; i <= column_data.length; i++){
                    var $column = $($layout.find('.column').get(0));
                    
                    $column.append('<hr>');
                    $column.append(column_data[i]);
                }
                
            }
            
            var layout = $layout.get(0);
            var html = layout.outerHTML;
            return html;
        },
        
        two_columns_large_right: function(current_data){
            var column_data = adapt.ui.layout.helper_functions.unwrap_columns(current_data);
            var $layout = $('<div class="layout not-editable"><div class="columns not-editable"><div class="column small editable"><p><br></p></div><div class="column large editable"><p><br></p></div></div></div>');
            
            if (column_data.length >= 1){  
                var $column = $($layout.find('.column.large').get(0));
                $column.empty();
                $column.append(column_data[0]);
            }
            
            if (column_data.length >= 2){
                var $column = $($layout.find('.column').not('.large').get(0));
                $column.empty();
                $column.append(column_data[1]);
            }
            
            if (column_data.length >= 3){
                for(var i = 2; i <= column_data.length; i++){
                    var $column = $($layout.find('.column.large').get(0));
                    
                    $column.append('<hr>');
                    $column.append(column_data[i]);
                }
                
            }
            
            var layout = $layout.get(0);
            var html = layout.outerHTML;
            return html;
        },
        
        two_columns_large_left: function(current_data){
            var column_data = adapt.ui.layout.helper_functions.unwrap_columns(current_data);
            var $layout = $('<div class="layout not-editable"><div class="columns not-editable"><div class="column large editable"><p><br></p></div><div class="column small editable"><p><br></p></div></div></div>');
            
            if (column_data.length >= 1){  
                var $column = $($layout.find('.column.large').get(0));
                $column.empty();
                $column.append(column_data[0]);
            }
            
            if (column_data.length >= 2){
                var $column = $($layout.find('.column').not('.large').get(0));
                $column.empty();
                $column.append(column_data[1]);
            }
            
            if (column_data.length >= 3){
                for(var i = 2; i <= column_data.length; i++){
                    var $column = $($layout.find('.column.large').get(0));
                    
                    $column.append('<hr>');
                    $column.append(column_data[i]);
                }
                
            }
            
            var layout = $layout.get(0);
            var html = layout.outerHTML;
            return html;
        },
        
        three_columns: function(current_data){
            var column_data = adapt.ui.layout.helper_functions.unwrap_columns(current_data);
            var $layout = $('<div class="layout not-editable"><div class="columns small not-editable"><div class="column editable"><p><br></p></div><div class="column medium editable"><p><br></p></div><div class="column small editable"><p><br></p></div></div></div>');
            
            if (column_data.length >= 1){  
                var $column = $($layout.find('.column.medium').get(0));
                $column.empty();
                $column.append(column_data[0]);
            }
            
            if (column_data.length >= 2){
                var $column = $($layout.find('.column').not('.medium').get(0));
                $column.empty();
                $column.append(column_data[1]);
            }
            
            if (column_data.length >= 3){
                for(var i = 2; i <= column_data.length; i++){
                    var $column = $($layout.find('.column.medium').get(0));
                    
                    $column.append('<hr>');
                    $column.append(column_data[i]);
                }
                
            }
            
            var layout = $layout.get(0);
            var html = layout.outerHTML;
            return html;
        },
        
        helper_functions: {
            unwrap_columns: function(data){
                var $data = $(data);
                
                if ($data.hasClass('layout')){
                    var output = [];
                    
                    var $large = $data.find('.column.large');
                    if ($large.length == 0){
                        $large = $data.find('.column.medium');
                        if ($large.length == 1) {
                            output.push($large.get(0).innerHTML);
                            $large.detach();
                        }
                    }else{
                        output.push($large.get(0).innerHTML);
                        $large.detach();
                    }
                    
                    var $columns = $data.find('.column');
                    for(var i = 0; i < $columns.length; i++){
                        output.push($columns.get(i).innerHTML);
                    }
                    
                    return output;
                }
                
                return [data];
            }
        }
    },
    
    views: {
        tag: function(icon, label, value_name, value){
            var $tag = $('<div></div>');
            
            $tag.append('<span class="view tag"></span>');
            $tag.find('.view.tag').append(adapt.ui.views.icon(icon));
            $tag.find('.view.tag').append('<span>' + label + '</span>');
            $tag.find('.view.tag').append('<input type="hidden" name="' + value_name + '" value="' + value + '" data-adapt-value="' + value + '">');
            
            var $a = $('<a href="#" class="control remove_tag"></a>').append(adapt.ui.views.icon('times'));
            $tag.find('.view.tag').append($a);
            
            return $tag.html();
        },

        element_frame: function(content){
            return '<div class="element frame not-editable"><div class="controls not-editable"></div><div class="content not-editable">' + content + '</div></div>';
        },
        
        wait: function(message){
            return "<h2>" + adapt.ui.views.icon('spinner fa-spin') + " " + message + "</h2>";
        },
        
        icon: function(name){
            return '<i class="view icon fa fa-' + name + ' not-editable">&nbsp;</i>';
        },
        
        button: function(label, classes){
            return '<button type="button" class="not-editable ' + classes + '">' + label + '</button>';
        },
        
        a: function(label, url, classes){
            return '<a href="' + url + '" class="' + classes + '">' + label + '</a>';
        },
        
        tabs: function(first_tab_label){
            var $tabs = $('<nav class="view tabs tab not-editable" id="' + adapt.ui.generate_id() + '"></nav>');
            $tabs.append('<ul class="nav nav-tabs not-editable"></ul>');
            $tabs.append('<div class="view clear not-editable"></div>');
            $tabs.append('<div class="tab-content not-editable"></div>');
            var tabs = $tabs.get(0);
            
            adapt.ui.event_handlers.add_tab(tabs, null, first_tab_label);
            
            
            var $frame = $(adapt.ui.views.element_frame(tabs.outerHTML));
            $frame.find('.controls').append(adapt.ui.views.a(adapt.ui.views.icon('plus') + " New tab", "#", "not-editable control new-tab"));
            $frame.find('.controls').append(adapt.ui.views.a(adapt.ui.views.icon('minus') + " Remove current tab", "#", "not-editable control remove-tab"));
            $frame.find('.controls').append(adapt.ui.views.a(adapt.ui.views.icon('trash-o') + " Remove tabs", "#", "not-editable control remove-tabs"));
            
            var html = "<p><br></p>" + $frame.get(0).outerHTML + "<p><br></p>";
            
            return html;
        },
        
        tab: function(label){
            var $tab = $('<li unselectable="on" class="not-editable"></li>');
            $tab.append('<a unselectable="on" class="not-editable" data-toggle="tab"><span contenteditable="true" class="editable">' + label + '</span></a>');

            var tab = $tab.get(0);
            return tab.outerHTML;
        },
        
        tab_pane: function(content){
            var $pane = $('<div class="tab-pane editable"></div>');
            if (content) {
                $pane.append(content);
            }else{
                $pane.append('<p><br></p>');
            }
            
            var pane = $pane.get(0);
            return pane.outerHTML;
        },
    },
    
    event_handlers: {
        remove_tag: function(tag, editor){
            $(tag).parent().detach();
        },
        
        remove_tab: function(tabs, editor){
            var $tabs = $(tabs);
            var id = $tabs.attr('id');

            var $content = $(editor.getContent());
            $content.find('#' + id).find('.active').detach();
            if($content.find('ul li').length >= 1){
                $content.find('ul li').first().addClass('active');
                $content.find('.tab-content .tab-pane').first().addClass('active');
                
                var html = adapt.ui.to_html($content);
                
                editor.setContent(html);
            }
            adapt.ui.attach_event_handlers($('.view.wiki').get(0), editor);
            
        },

        remove_tabs: function(tabs, editor){
            var $tabs = $(tabs);
            var id = $tabs.attr('id');
            var $content = $("<div>" + editor.getContent() + "</div>");

            $content.find('#' + id).parents('.element.frame').detach();

            var html = $content.html();
            editor.setContent(html);
            adapt.ui.attach_event_handlers($('.view.wiki').get(0), editor);
        },
        
        request_new_tab: function(tabs, editor){
            /*
             * This is called instead of add_tab because IE
             * refuses to allow the tab label to be edited,
             * to work around we call this an prompt for the tab label
             */
            var $tabs = $(tabs);
            var id = $tabs.attr('id');
            
            if (editor){
                editor.windowManager.open({
                    title: 'Add tab',
                    body: [
                        {type: 'textbox', name: 'label', label: 'Tab label', value: ''}
                    ],
                    onsubmit: function(event){
                        if (event.data.label == ""){
                            editor.windowManager.alert("You must specify a label for the tab");
                        }else{
                            adapt.ui.event_handlers.add_tab(tabs, editor, event.data.label);
                        }
                    }
                });
            }
        },
        
        add_tab: function(tabs, editor, label){
            var $tabs = $(tabs);
            var id = $tabs.attr('id');
            
            if (!label) {
                label = "Change me";
            }
            
            var tab_id = adapt.ui.generate_id();
            
            if (editor) {
                var content = "<div>" + editor.getContent() + "</div>";
                var $content = $(content);
                $tabs = $content.find('#' + id);
                var $tab = $(adapt.ui.views.tab(label));
                var $pane = $(adapt.ui.views.tab_pane('<p>Tab content here<br></p>'));
                $tabs.find('*').removeClass('active');
                
                $tab.find('[data-toggle="tab"]').attr('href', '#' + tab_id);
                $pane.attr('id', tab_id);
                
                $tabs.find('ul.nav').append($tab);
                $tabs.find('.tab-content').append($pane);
                
                $tab.find('a[data-toggle="tab"]').tab('show');
                $pane.addClass('active');
                
                content = $content.get(0).innerHTML;
                
                editor.setContent(content);
                adapt.ui.attach_event_handlers($('.view.wiki').get(0), editor);
            }else{
                var $tab = $(adapt.ui.views.tab(label));
                var $pane = $(adapt.ui.views.tab_pane('<p>Tab content here<br></p>'));
                var $tabs = $(tabs);
                $tabs.find('*').removeClass('active');
                
                $tab.find('[data-toggle="tab"]').attr('href', '#' + tab_id);
                $pane.attr('id', tab_id);

                $tabs.find('ul.nav').append($tab);
                $tabs.find('.tab-content').append($pane);
                
                $tab.find('a[data-toggle="tab"]').tab('show');
                $pane.addClass('active');
            }
        },
    },
    
    attach_event_handlers: function(view, editor){
        var $view = $();
        if (view) {
            $view = $(view);
        }

        /* Tabs */
        $view.find('.view.tabs').parents('.element.frame').find('.controls .control.new-tab').on(
            'click',
            null,
            { editor },
            function(event){
                var $tabs = $(this).parents('.element.frame').find('.view.tabs');
                adapt.ui.event_handlers.request_new_tab($tabs.get(0), event.data.editor);
            }
        ).on( /* IE Fix */
            'mousedown',
            null,
            {
                editor: editor
            },
            function (event){
                if (navigator.userAgent.indexOf("MSIE") > 0) {
                    var $tabs = $(this).parents('.element.frame').find('.view.tabs');
                    adapt.ui.event_handlers.request_new_tab($tabs.get(0), event.data.editor);
                }
            }
        );
        
        $view.find('.view.tabs').parents('.element.frame').find('.controls .control.remove-tabs').on(
            'click',
            null,
            { editor },
            function(event){
                var $tabs = $(this).parents('.element.frame').find('.view.tabs');
                adapt.ui.event_handlers.remove_tabs($tabs.get(0), event.data.editor);
            }
        ).on( /* IE Fix */
            'mousedown',
            null,
            { editor },
            function (event){
                if (navigator.userAgent.indexOf("MSIE") > 0) {
                    var $tabs = $(this).parents('.element.frame').find('.view.tabs');
                    adapt.ui.event_handlers.remove_tabs($tabs.get(0), event.data.editor);
                }
            }
        );
        
        $view.find('.view.tabs').parents('.element.frame').find('.controls .control.remove-tab').on(
            'click',
            null,
            { editor },
            function(event){
                var $tabs = $(this).parents('.element.frame').find('.view.tabs');
                adapt.ui.event_handlers.remove_tab($tabs.get(0), event.data.editor);
            }
        ).on( /* IE Fix */
            'mousedown',
            null,
            { editor },
            function (event){
                if (navigator.userAgent.indexOf("MSIE") > 0) {
                    var $tabs = $(this).parents('.element.frame').find('.view.tabs');
                    adapt.ui.event_handlers.remove_tab($tabs.get(0), event.data.editor);
                }
            }
        );

        /* Tags */
        $('.control.remove_tag').on(
            'click',
            null,
            { editor },
            function(event){
                adapt.ui.event_handlers.remove_tag(this, event.data.editor);
            }
        );

        /* Prevent enter key from submitting wiki form */
        $('.view.modal input[type="text"]').on(
            'keydown',
            function(event){
                if (event.keyCode == 13){
                    event.preventDefault();
                    return false;
                }
            }
        );
    },
    
    generate_id: function(){
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for( var i=0; i < 10; i++ ) text += possible.charAt(Math.floor(Math.random() * possible.length));
        return "adapt-id-" + text;
    },
    
    to_html: function($object){
        var output = "";
        for(var i = 0; i < $object.length; i++){
            var html = $object.get(i);
            html = html.outerHTML;
            
            if (typeof html != 'undefined') output = output + html;
        }
        
        return output;
    }
};
